const SIZESECONLIST = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  220,
  230,
  240,
  250,
  260,
  270,
  280,
  290,
  300,
  'FREE',
];
export default SIZESECONLIST;
